<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-btn dark icon @click="dialogEditAvatar=true" title="Change avatar">
                        <v-icon>photo_camera</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            
            <!-- TODO for refactoring - create component to be shared in MyProfile and UserProfile -->

            <v-expansion-panel v-model="panel" expand v-if="!loading&&employment_info!=null">
                <!-- EMPLOYEE DETAILS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-4px;':''">PERSONAL DETAILS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent" > 
                        <v-toolbar class="transparent" flat height="25">
                            <v-spacer></v-spacer>
                            <v-btn icon title="Edit Employee Details" @click="showEditMember">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text v-if="!loading">
                            <personal-details :basic_info="basic_info" :address_info="address_info"></personal-details>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- TEAM MEMBERSHIPS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-4px;':''">TEAM MEMBERSHIPS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1">
                        <v-card-text v-if="!loading">
                            <v-card class="elevation-1">
                                <v-data-table
                                    :headers="headers"
                                    :items="team_membership"
                                    :loading="loading"
                                    hide-actions
                                >  
                                    <template v-slot:items="props">
                                        <tr>
                                            <td>{{ props.item.team }}</td>
                                            <td>{{ props.item.role }}</td>
                                            <td>
                                                <v-chip v-if="props.item.supervisor" style="margin:-5px 0px 0px -5px;">
                                                    <v-avatar>
                                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.supervisor.userId)"></v-img>
                                                    </v-avatar>
                                                    {{props.item.supervisor.firstName}} {{props.item.supervisor.lastName}}
                                                </v-chip>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table> 
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                
                <!-- EMPLOYMENT DETAILS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-4px;':''">EMPLOYMENT</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-toolbar class="transparent" flat height="25">
                            <v-spacer></v-spacer>
                            <v-btn icon title="Edit Employment" @click="showEditEmployment">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text v-if="!loading&&employment_info!=null">
                            <v-layout row wrap> 
                            <v-flex xs12 sm6>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Type :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{commonfn.getStatusDescription(employment_info.employmentType)}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Start Date : 
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{employment_info.startDate|moment('MMM DD, YYYY')}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Status : 
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{commonfn.getStatusDescription(employment_info.employmentStatus)}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout v-if="employment_info.employmentStatus==commonfn.getStatusCode('Resigned')" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Last working date : 
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{employment_info.endDate|moment('MMM DD, YYYY')}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Position :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{employment_info.position}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Salary Type :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{salaryType}}
                                    </v-flex>  
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        TIN :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{formattedTIN}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        SSS :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{formattedSSS}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Pagibig :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{formattedPagibig}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Philhealth :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{formattedPhilhealth}}
                                    </v-flex>  
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- BANK DETAILS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-4px;':''">BANK DETAILS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-toolbar class="transparent" flat height="25">
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text v-if="!loading&&employment_info!=null">
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Bank : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{bank_account!=null?bank_account.bankName:'Not Updated'}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Branch : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{bank_account!=null?bank_account.bankBranch:'Not Updated'}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Bank Account : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{bank_account!=null?bank_account.bankAccount:'Not Updated'}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedUserId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogUpdate" persistent width="700">
            <update-member ref="updateMemberDialog" :dialogUpdate.sync="dialogUpdate" @send="getMyProfile"></update-member>
        </v-dialog>
        <v-dialog v-model="dialogEditAvatar" fullscreen hide-overlay transition="dialog-bottom-transition"> 
            <edit-avatar :dialogEditAvatar.sync="dialogEditAvatar" @send="refreshAvatar"></edit-avatar>
        </v-dialog>
        <v-dialog v-model="dialogEmployment" persistent width="600">
            <update-employment ref="refEmployment" :dialogEmployment.sync="dialogEmployment" @send="getMyProfile"></update-employment>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedUserId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import userApi from '@/api/user'
import commonfn from '@/common/functions'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import commonData from '@/common/data'
import awsS3Helper from '@/helpers/aws-s3'

export default {  
    name: 'MyProfile',
    metaInfo: {
        title: 'My Profile',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View my other team member profile' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'personal-details': () => import('@/components/201Files/PersonalDetails'),
        'update-member': () => import("@/components/ManageTeam/UpdateMember"),
        'update-employment': () => import("@/components/ManageTeam/EditEmployment"),
        'edit-avatar': () => import("@/components/Users/EditAvatar"),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },      
    data () {
        return {
            loading: false,
            error: false,
            errorMessage: '', 
            headers: [
                    {text:'Team', align: 'left',value:'team', width:'33%', sortable:false},
                    {text:'Role', align: 'left',value:'role', width:'33%', sortable:false},
                    {text:'Immediate Supervisor', align: 'left',value:'supervisor', width:'33%', sortable:false},                    
                ], 
            panel: [true],
            dialogEditAvatar: false,
            dialogUpdate: false,
            basic_info: null,
            address_info: null,
            employment_info: null,
            bank_account: null,
            team_membership: [],
            dialogEmployment: false,
            dialogUpdateTeam: false,
            dialogUpdateBank: false
        }
    },
    methods: {
        showEditEmployment() {
            this.$refs.refEmployment.setParams(false, this.basic_info, this.employment_info)
            this.dialogEmployment = true
        },
        refreshAvatar() {
            this.$refs.avatar.src = this.myProfileAvatar
        },
        showEditMember() {
            this.$refs.updateMemberDialog.setParamsEdit(this.basic_info, this.address_info)
            this.dialogUpdate=true
        },
        async getMyProfile(){
            try{
                const response = await userApi.getMyProfile()
                if (response && response.status == 200) {
                    this.basic_info = response.data.basicInfo
                    this.address_info = response.data.address
                    this.employment_info = response.data.employment
                    this.team_membership = response.data.teamMembership
                    this.bank_account = response.data.bankAccount
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        this.commonfn = commonfn
        this.awsS3Helper = awsS3Helper
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'My Profile',
            avatarPath: this.myProfileAvatar
        })

        this.getMyProfile()
    },
    computed: {
        selectedUserId() {
            return this.$store.state.userId
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.selectedUserId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.employees,
                    notificationTypeId: notificationTypes.myprofile
                }
            }
        },
        myProfileAvatar() {
            return this.$store.state.avatar
        },
        headerImage() {
            return this.$store.state.headerImg.replace('.darken1','').replace('.darken2','').replace('.darken3','').replace('.darken4','') 
        },
        isMobile() {
            return window.innerWidth < 600
        },
        salaryType() {
            if (this.employment_info) {
                return commonData.salary_types.filter(x => x.salaryType == this.employment_info.salaryType)[0].name
            }
        },
        page_title_class() {
            if (this.isMobile) return 'margin:19px 0px 0px 22px;'
            else return 'margin:5px 0px 0px 30px;'
        },
        myAvatar() {
            if (this.$store.state.avatar==null) return 'default.png'
            else return this.$store.state.avatar
        },
        cellPhone() {
            if (this.basic_info.phone!=null)
                return `+63-${this.basic_info.phone.substring(2,5)}-${this.basic_info.phone.substring(5,12)}`
        },
        formattedTIN() {
            if (this.employment_info.tin!=null)
                return `${this.employment_info.tin.substring(0,3)}-${this.employment_info.tin.substring(3,6)}-${this.employment_info.tin.substring(6,9)}`
        },
        formattedSSS() {
            if (this.employment_info.sss!=null)
                return `${this.employment_info.sss.substring(0,2)}-${this.employment_info.sss.substring(2,9)}-${this.employment_info.sss.substring(9,10)}`
        },
        formattedPagibig() {
            if (this.employment_info.pagibig!=null)
                return `${this.employment_info.pagibig.substring(0,4)}-${this.employment_info.pagibig.substring(4,8)}-${this.employment_info.pagibig.substring(8,12)}`
        },
        formattedPhilhealth() {
            if (this.employment_info.philhealth!=null)
                return `${this.employment_info.philhealth.substring(0,2)}-${this.employment_info.philhealth.substring(2,11)}-${this.employment_info.philhealth.substring(11,12)}`
        }
    },
}
</script>
<style scoped>
    .section-layout {
        padding:0px 20px 0px 50px;
    }
    .section-layout-mobile {
        padding:0px 0px 0px 5px;
    }
</style>